import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CodeSnippet, SeeExample, getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { InsertInstruction } from '../../components/insert-instructions';
import { CopyDownloadTag } from '../../components/copy-download-tag';
import { tagSetupExampleTemplates } from '../../../shared/contants';

const TagSetupInstallManuallyStepViewUnstyled = (props) => {
  const {
    classes,
    i18n,
    tagId,
    uetTagInstructions,
    logActivity,
    wizardDispatch,
    tagTemplates,
    permissions,
  } = props;

  const copyCallback = useCallback((res) => {
    if (res && res.error) {
      logActivity.error(JSON.stringify(res));
    }
    logActivity.trace('Base tag copy clicked');
  }, [logActivity]);

  const downloadCallback = useCallback((res) => {
    if (res && res.error) {
      logActivity.error(JSON.stringify(res));
    }
    logActivity.trace('Base tag download clicked');
  }, [logActivity]);

  return (
    <div className={classNames(classes.contentBlock, 'copy-tag-view')}>
      <div className={classes.section}>
        <InsertInstruction
          i18n={i18n}
          template={uetTagInstructions}
          logActivity={logActivity}
          wizardDispatch={wizardDispatch}
          permissions={permissions}
        />
      </div>
      <CodeSnippet
        model={{ tagId }}
        codeTemplate={tagTemplates.UET.join('\n')}
      />
      <div className={classes.section}>
        <CopyDownloadTag
          model={{ tagId }}
          type="UET"
          instructionsTemplate={uetTagInstructions.slice(0, -1)}
          onCopyCallback={copyCallback}
          onDownloadCallback={downloadCallback}
          tagTemplates={tagTemplates}
          logActivity={logActivity}
          wizardDispatch={wizardDispatch}
          permissions={permissions}
        />
      </div>
      <SeeExample
        i18n={i18n}
        message={i18n.getString(_TL_('Please paste the UET tag (shown above) to every page of your website.'))}
        exampleTemplate={tagTemplates[tagSetupExampleTemplates.UET].join('\n')}
      />
    </div>
  );
};

TagSetupInstallManuallyStepViewUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  tagId: PropTypes.number.isRequired,
  uetTagInstructions: PropTypes.arrayOf(PropTypes.any).isRequired,
  logActivity: PropTypes.shape({}).isRequired,
  wizardDispatch: PropTypes.func.isRequired,
  tagTemplates: PropTypes.objectOf(PropTypes.any).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};

export const TagSetupInstallManuallyStepView = withDefaultStyles(TagSetupInstallManuallyStepViewUnstyled, getStepStyles);
